import React, { useState } from 'react';
import { t } from '../../../i18n';
import { openPhotoPicker } from '../../../utils/appRuntime';
import { CloudUploadOutlined } from '@ant-design/icons';

const kDefaultMinPhotos = 1;
const kDefaultMaxPhotos = 3;

/**
 * 相册多选
 */
interface MultiPhotoSelectorViewProps {
    minPhotos?: number;
    maxPhotos?: number;
    onPhotoSelected: (photos: string[]) => void;
    cameraText?:string
}

const MultiPhotoSelectorView: React.FC<MultiPhotoSelectorViewProps> = ({
    minPhotos = kDefaultMinPhotos,
    maxPhotos = kDefaultMaxPhotos,
    onPhotoSelected,
    cameraText = ""
}) => {
    const handleConfirmUpload = () => {
        openPhotoPicker(maxPhotos, Math.max(minPhotos, kDefaultMinPhotos), cameraText || t('pages.delivery.detail.requiredPhotos'), onPhotoSelected);
    };

    return (
        <>
            <div className="flex items-center gap-2">
                <span className="text-[13px] text-gray-700">
                    {t('pages.delivery.detail.cantTakePhotos')}
                </span>
                <div className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md bg-white" onClick={handleConfirmUpload}>
                    <span className="text-[13px] text-gray-700 font-medium">
                        {t('pages.delivery.detail.uploadFromAlbum')}
                    </span>
                    <CloudUploadOutlined className="text-gray-500 text-lg" />
                </div>
            </div>
        </>
    );
};

export default MultiPhotoSelectorView;
